import React from 'react';

const NotFound = () => <h1>Nerasta wwwww</h1>;

export default NotFound;
